import React, { Component } from 'react';

// Email parts are never concatenated as a literal full address in source.
// The "@" and "." are inserted at render time via JS, so static HTML/regex
// harvesters scanning the raw bundle for "user@domain" patterns find nothing.
const contacts = [
  { label: 'General',  user: 'info',    host: 'foreignsix', tld: 'com' },
  { label: 'Sales',    user: 'sales',   host: 'foreignsix', tld: 'com' },
  { label: 'Support',  user: 'support', host: 'foreignsix', tld: 'com' },
];

function buildAddress(user, host, tld) {
  return `${user}\u0040${host}\u002E${tld}`;
}

export default class Contact extends Component {
  render() {
    return (
      <div className="modal fade" id="contactModal" tabIndex="-1" aria-labelledby="contactModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-dark text-light border border-secondary">
            <div className="modal-header border-secondary">
              <h5 className="modal-title text-info" id="contactModalLabel">Contact ForeignSix</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p className="text-secondary mb-4">
                Reach out to the right team and we'll get back to you promptly.
              </p>
              <ul className="list-unstyled mb-4">
                {contacts.map(({ label, user, host, tld }) => {
                  const addr = buildAddress(user, host, tld);
                  return (
                    <li key={label} className="mb-3 d-flex align-items-center">
                      <span className="text-secondary me-2" style={{ width: '4.5rem', display: 'inline-block' }}>{label}</span>
                      <a
                        href={`mailto:${addr}`}
                        className="text-info text-decoration-none"
                      >
                        {addr}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <div className="border-top border-secondary pt-3">
                <p className="text-secondary small mb-1">Registered address</p>
                <address className="text-secondary small mb-0" style={{ fontStyle: 'normal' }}>
                  ForeignSix LLC<br />
                  254 Chapman Rd, Ste 208 #27600<br />
                  Newark, Delaware 19702<br />
                  United States
                </address>
              </div>
            </div>
            <div className="modal-footer border-secondary">
              <button type="button" className="btn btn-outline-secondary btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
